import React from "react";


export default function Loader() {
  return (
    <div id="loader">
      Cargando...
    </div>
  ) 
}